module.exports = __webpack_public_path__ + "img/computer.64bf5ced.svg";